__turbopack_context__.v({
  "readmoreBtnStyles": "_7C8S6q_readmoreBtnStyles",
  "readmoreBtnStylesReverce": "_7C8S6q_readmoreBtnStylesReverce",
});
